import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_SurveyComponent = _resolveComponent("SurveyComponent")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, { mode: "md" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { mode: "md" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              slot: "start",
              style: {"--border-radius":"10px","--background-hover":"var(--ion-color-danger)","--background":"var(--ion-color-danger)"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Close Checklist")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-no-padding",
      style: {"--background":"#f3f3f3"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SurveyComponent, {
          model: _ctx.survey,
          style: {"width":"100%","height":"100%"}
        }, null, 8, ["model"])
      ]),
      _: 1
    })
  ], 64))
}